"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeRedeem = require("@/api/marketing/free-redeem");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var statusOptions = [{
  value: 1,
  label: '未使用'
}, {
  value: 2,
  label: '已使用'
}, {
  value: 3,
  label: '已失效'
}];
var _default = exports.default = {
  name: 'LotteryAssistantRecord',
  data: function data() {
    return {
      loading: false,
      total: 0,
      recordList: [],
      statusOptions: statusOptions,
      queryParams: {
        page: 1,
        limit: 20,
        batchId: '',
        exchangeCode: ''
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:free-redeem:record'])) {
      this.getList();
    } else {
      this.$message.error('对不起，您没有访问权限');
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _freeRedeem.freeRedeemRecordListApi)(this.queryParams).then(function (res) {
        _this.recordList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 20,
        batchId: '',
        exchangeCode: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      //选择多少条数据
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    formatter: function formatter(value, key) {
      if (key === 'status') {
        var target = statusOptions.find(function (item) {
          return item.value === value;
        });
        return target ? target.label : value;
      }
      return '-';
    }
  }
};